module.exports = __webpack_public_path__ + "img/1f6a8.a5a4220.svg";